import { IBuyBarProductSizeOption, IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';

const getInitialSlideIndex = (
  availableSizes: IBuyBarProductVariant[],
  buyBarItems: (IBuyBarProductVariant | IBuyBarProductSizeOption)[],
  hasPlentySlides: boolean,
) => {
  // If we don't have any available sizes, we want to show the first slide or the middle slide if there are plenty of slides
  if (!availableSizes || availableSizes.length <= 0) {
    return hasPlentySlides ? 0 : Math.floor(buyBarItems.length / 2);
  }

  // If we have available sizes, we want to show the lowest priced available size
  let lowestAvailablePriceIndex = 0;
  for (let index = 1; index < availableSizes.length; index += 1) {
    if (
      availableSizes[index]?.lowestPriceCents?.amount <
      availableSizes[lowestAvailablePriceIndex]?.lowestPriceCents?.amount
    ) {
      lowestAvailablePriceIndex = index;
    }
  }

  const lowestPriceItemIndex = buyBarItems.findIndex(
    (variant) =>
      variant?.sizeOption.value === availableSizes[lowestAvailablePriceIndex]?.sizeOption.value,
  );

  return lowestPriceItemIndex === -1 ? 0 : lowestPriceItemIndex;
};
export default getInitialSlideIndex;
